import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/student-search`;

class StudentSearchService {
  /** Fetch all dropdown/lookup data for the search form */
  getLookups = () => myAxios.get<any>(`${BASE}/lookups`);

  /** Type-ahead for the Batch filter — matches batch name / code / display name */
  searchBatches = (q: string) =>
    myAxios.get<any>(`${BASE}/batches`, { params: { q } });

  /** Execute a student search with all filter criteria (includes password credentials) */
  search = (params: any) => myAxios.post<any>(`${BASE}/search`, params);

  /** Execute a password-focused search (automatically sets passwordSearch: true) */
  passwordSearch = (params: any) =>
    myAxios.post<any>(`${BASE}/search`, { ...params, passwordSearch: true });

  /** Send bulk message (SMS/Email/WhatsApp/Notification) */
  sendBulkMessage = (params: any) =>
    myAxios.post<any>(`${BASE}/bulk-message`, params);

  /** Preview available columns for Excel export */
  previewExcel = (params: any) =>
    myAxios.post<any>(`${BASE}/preview-excel`, params);

  /** Generate and download Excel export */
  exportExcel = (params: any) =>
    myAxios.post<any>(`${BASE}/export-excel`, params);

  /** Export filtered enquiries for bulk update (2-sheet Excel) — returns blob */
  bulkUpdateExport = (params: any) =>
    myAxios.post(`${BASE}/bulk-update/export`, params, { responseType: "blob" });

  /** Validate uploaded bulk-update rows and get diff preview */
  bulkUpdateValidate = (params: any) =>
    myAxios.post<any>(`${BASE}/bulk-update/validate`, params);

  /** Apply validated bulk updates */
  bulkUpdateApply = (params: any) =>
    myAxios.post<any>(`${BASE}/bulk-update/apply`, params);

  /** Soft-delete an enquiry (and cascade to its enrollments + linked users) */
  deleteEnquiry = (enquiryId: number) =>
    myAxios.post<any>(`${BASE}/delete-enquiry`, { enquiryId });
}

export default new StudentSearchService();
